// extracted by mini-css-extract-plugin
export default {"bulkBlock":"bulkBlock--sJ4DJ"};